var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitePlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9431,
    cy: 22.9978,
    r: 22.2947,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8740_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1139 21.6871H24.2543V13.8275C24.2543 13.1041 23.6678 12.5176 22.9443 12.5176C22.2209 12.5176 21.6344 13.1041 21.6344 13.8275V21.6871H13.7748C13.0513 21.6871 12.4648 22.2736 12.4648 22.9971C12.4648 23.7205 13.0513 24.307 13.7748 24.307H21.6344V32.1666C21.6344 32.89 22.2209 33.4765 22.9443 33.4765C23.6678 33.4765 24.2543 32.89 24.2543 32.1666V24.307H32.1139C32.8373 24.307 33.4238 23.7205 33.4238 22.9971C33.4238 22.2736 32.8373 21.6871 32.1139 21.6871Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8740_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.959,
    height: 20.959,
    fill: "white",
    transform: "translate(12.4648 12.5176)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlusIcon);
export default __webpack_public_path__ + "static/media/whitePlusIcon.5e9eaf98bd6e9117beb0bfd96ce045ea.svg";
export { ForwardRef as ReactComponent };